import type { IconNode } from '../types';

/**
 * @name shark
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMy42IDE1YTkuMDcgOS4wNyAwIDAgMCAxMS43IDUuM1MxOSAyMiAyMiAyMmMwIDAtMS0zLTMtNC41IDEuMS0xLjUgMS45LTMuMyAyLTUuM2wtOCA0LjZhMS45NCAxLjk0IDAgMSAxLTItMy40bDYtMy41czUtMi44IDUtNi44YzAtLjYtLjQtMS0xLTFoLTljLTEuOCAwLTMuNC41LTQuOCAxLjVDNS43IDIuNSAzLjkgMiAyIDJjMCAwIDEuNCAyLjEgMi4zIDQuNUExMC42MyAxMC42MyAwIDAgMCAzLjEgMTMiIC8+CiAgPHBhdGggZD0iTTEzLjggNyAxMyA2IiAvPgogIDxwYXRoIGQ9Ik0yMS4xMiA2aC0zLjVjLTEuMSAwLTIuOC41LTMuODIgMUw5IDkuOEMzIDExIDIgMTUgMiAxNWg0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/shark
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const shark: IconNode = [
  [
    'path',
    {
      d: 'M3.6 15a9.07 9.07 0 0 0 11.7 5.3S19 22 22 22c0 0-1-3-3-4.5 1.1-1.5 1.9-3.3 2-5.3l-8 4.6a1.94 1.94 0 1 1-2-3.4l6-3.5s5-2.8 5-6.8c0-.6-.4-1-1-1h-9c-1.8 0-3.4.5-4.8 1.5C5.7 2.5 3.9 2 2 2c0 0 1.4 2.1 2.3 4.5A10.63 10.63 0 0 0 3.1 13',
      key: '3bbkru',
    },
  ],
  ['path', { d: 'M13.8 7 13 6', key: '1027rq' }],
  ['path', { d: 'M21.12 6h-3.5c-1.1 0-2.8.5-3.82 1L9 9.8C3 11 2 15 2 15h4', key: '1teih8' }],
];

export default shark;
